/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable func-names */
/* eslint-disable react/prop-types */
import React, { useState, useEffect } from 'react';
import history from '../../utils/history';
import ClearAbsenceForm from './AccordionForm';
import LoadingIndicatorAtCenter from '../../View/LoadingIndicatorAtCenter';
import { errMsg } from '../../utils/messages';
import Header from '../../View/Header/DirectLinkAccessHeader';
import api from '../../utils/api';
import { GET_ABSENCES_DATA_LINK } from '../../utils/apiEndPoint';
import Form from '../EarlyLeaveForm/Form';

const ClearAbsence = ({ match }) => {
  const { school, studentId, token } = match.params;

  const [msg, setMsg] = useState('');
  const [status, setStatus] = useState(0);
  const [showEarlyLeaveForm, setShowEarlyLeaveForm] = useState(false);
  const [loading, setLoading] = useState(true);
  const [reasons, setReasons] = useState({})
  const userDetails = JSON.parse(sessionStorage.getItem('data'));

 const getAbsencesDataLink = () => {
    const url = `${GET_ABSENCES_DATA_LINK}/${school}/${studentId}/${token}`;
    api.get(url)
      .then((response) => {
        if (response.status === 200 || response.status === 302) {
          setStatus(response.status);
          setMsg(response.msg);
          setReasons(response?.data?.macs_aeries_codes)
          const loginDetails = {
            studentId: response.data.student_id,
            birthdate: response.data.birthdate,
          };
          sessionStorage.setItem('login_details', JSON.stringify(loginDetails));
          sessionStorage.setItem('data', JSON.stringify(response.data));
        } else if (response.status === 401) {
          setMsg(response.msg);
          setStatus(response.status);
        } else {
          setMsg(errMsg);
          setStatus(0);
        }
        setLoading(false);
      })
      .catch((error) => {
        if (error) {
          setLoading(false);
          setMsg(errMsg);
          setStatus(0);
        }
      });
  };

  useEffect(() => {
    sessionStorage.setItem('token', token);
    getAbsencesDataLink();
    window.onpopstate = function () {
      history.go(1);
    };
  },[]);
 
  let currentPage;

  if (loading) {
    currentPage = (
      <LoadingIndicatorAtCenter />
    );
  } else if (status === 200 || status === 302) {
    currentPage = (
      <>
        <Header data={userDetails} />
        <div className="right-box-wrapper profile-main-box">
          {showEarlyLeaveForm ? (
            <Form setShowEarlyLeaveForm={setShowEarlyLeaveForm} reasons={reasons} />
          ) : (
            <ClearAbsenceForm
              msg={msg}
              status={status}
              setShowEarlyLeaveForm={setShowEarlyLeaveForm}
              // reasons={reasons}
              reasons={reasons}
            />
          )}
        </div>
      </>
    );
  } else if (status === 401 && msg.includes('ECR\'s Contactless Attendance System (CAS)')) {
    currentPage = (
      <div className="error-container">
        <div className="error-box e_box">
          <h3>EXPIRED LINK NOTIFICATION</h3>
          <p>
            {msg.replace('ECR\'s Contactless Attendance System (CAS)', '')}
            <a href="https://attendance.schoolriver.com">
              ECR&apos;s Contactless Attendance System (CAS)
            </a>
          </p>
        </div>
      </div>
    );
  } else {
    currentPage = (
      <div className="error-container">
        <div className="error-box">
          <p style={{
            textAlign: 'center',
            padding: 24,
            color: 'red',
          }}
          >
            {msg}
          </p>
        </div>
      </div>
    );
  }
  return (<>{ currentPage }</>);
};

export default ClearAbsence;
